import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { fillLegalTemplate } from '@/lib/legalTemplate'

type Section = { title: string; paragraphs: string[] }

export function PrivacyPolicyPage() {
  const { t } = useTranslation()
  const sections = t('legal.privacy.sections', { returnObjects: true }) as Section[]
  const contactEmail = t('common.contactEmail')
  const vars = {
    appName: t('common.appName'),
    companyName: t('common.companyName'),
    contactEmail,
  }

  const intro = fillLegalTemplate(t('legal.privacy.intro'), vars)
  const effectiveDate = t('legal.privacy.effectiveDate')
  const disclaimer = t('legal.privacy.disclaimer')

  return (
    <div className="min-h-screen" style={{ background: '#F0F4FF' }}>
      <div className="pt-16" style={{ background: 'linear-gradient(135deg, #0D1B3E 0%, #1A2E5A 100%)' }}>
        <div className="mx-auto max-w-4xl px-4 py-16 text-center sm:px-6 lg:px-8">
          <h1
            style={{
              fontFamily: 'Outfit, sans-serif',
              fontWeight: 900,
              fontSize: 'clamp(28px, 4vw, 48px)',
              color: 'white',
              letterSpacing: '-0.04em',
              marginBottom: 0,
            }}
          >
            {t('legal.privacy.title')}
          </h1>
        </div>
      </div>

      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="minego-card minego-prose p-8 sm:p-12">
          <p style={{ fontStyle: 'italic', color: '#6B7A99' }}>{effectiveDate}</p>
          <p>{intro}</p>
          {sections.map((section) => (
            <section key={section.title}>
              <h2>{section.title}</h2>
              {section.paragraphs.map((para, idx) => (
                <p key={`${section.title}-${idx}`}>{fillLegalTemplate(para, vars)}</p>
              ))}
            </section>
          ))}
          <p style={{ fontWeight: 700, color: '#C0392B', marginTop: '2rem', lineHeight: 1.8 }}>
            {disclaimer}
          </p>
          <hr style={{ margin: '2rem 0', borderColor: '#E2E8F0' }} />
          <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '15px', color: '#6B7A99', lineHeight: 1.7 }}>
            <Trans
              i18nKey="legal.footer.contact"
              values={{ email: contactEmail }}
              components={{
                supportLink: <Link to="/support" className="text-[#1A56FF] underline" />,
                emailLink: <a href={`mailto:${contactEmail}`} className="text-[#1A56FF] underline" />,
              }}
            />
          </p>
          <p>
            {t('legal.privacy.title')} ·{' '}
            <Link to="/terms-of-service" className="text-[#1A56FF] underline">
              {t('nav.terms')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
